import { useEffect } from 'react';
import { useProjectContext } from '@gonfalon/app-context/useProjectContext';
import { enableSdkNotifications as enableSdkNotificationsContext } from '@gonfalon/dogfood-flags/dogfood-flags';
import { useQuery } from '@tanstack/react-query';
import nullthrows from 'nullthrows';

import { iterateAndDisplayNotifications } from '#components/SdkNotification/sdkNotificationUtils';
import { getContextUsageSdks } from '#sources/ContextUsageAPI';

const enableSdkNotifications = enableSdkNotificationsContext();

export const useSdkNotification = () => {
  const projectContext = useProjectContext({ optional: true });
  const projKey = projectContext?.context.projectKey;
  const envKey = projectContext?.context.selectedEnvironmentKey;

  const { data: sdks } = useQuery({
    queryKey: ['context-usage-sdks', projKey, envKey],
    queryFn: () =>
      getContextUsageSdks(
        nullthrows(projKey, 'expected projKey in useSdkNotification query'),
        nullthrows(envKey, 'expected envKey in useSdkNotification query'),
      ),

    enabled: enableSdkNotifications && !!projKey && !!envKey,
  });

  useEffect(() => {
    if (sdks && projKey && envKey) {
      const timeout = setTimeout(() => {
        iterateAndDisplayNotifications(sdks, projKey, envKey);
      }, 5000);

      return () => clearTimeout(timeout);
    }
  }, [sdks, projKey, envKey]);
};
